export default function PlaceholderImage({ src, alt = "", crop = {} }) {
  const { top = 0, right = 0, bottom = 0, left = 0 } = crop;

  return (
    <div
      className="placeholder"
      style={{
        overflow: "hidden",
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: `calc(100% + ${left + right}px)`,
          height: `calc(100% + ${top + bottom}px)`,
          transform: `translate(-${left}px, -${top}px)`,
          objectFit: "cover",
          display: "block",
        }}
      />
    </div>
  );
}
